// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
//首页
import Home from '@/views/home/index';
import Oil from '@/views/home/repair';

// 基本设置
import BasicSetting from '@/views/basicSetting/index';
import Ad from '@/views/ad/index';
import UserGroup from '@/views/auth/userGroup';
import Manager from '@/views/auth/manager';
import Menu from '@/views/auth/menu';

import Notice from '@/views/notice/index';
import White from '@/views/auth/white';
import Spread from '@/views/Spread/Spread';
import GeneralDevice from '@/views/generalDevice/generalDevice';
import weatherDevice from '@/views/weatherDevice/weatherDevice';
import protocal from '@/views/protocal/protocal';
import course from '@/views/course/course';
import alarm from '@/views/alarm/alarm';
import log from '@/views/log/log';
import wechatUser from '@/views/wechatUser/wechatUser';
import wechatManager from '@/views/wechatManager/wechatManager';
import Repair from '@/views/repair/repair';
import apiAuth from '@/views/apiAuth/index';

/**
 * 数据监控
 */
// 监控查询

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
    {
      path: '/',
      name: '',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/home/index',
          name: '首页',
          component: Home,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/repair',
          name: '机油剩余时间',
          component: Oil,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/basicSetting/index',
          name: '基本设置',
          component: BasicSetting,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/ad/index',
          name: '广告设置',
          component: Ad,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/auth/userGroup',
          name: '用户组管理',
          component: UserGroup,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/auth/manager',
          name: '管理员管理',
          component: Manager,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/auth/menu',
          name: '菜单管理',
          component: Menu,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/notice/index',
          name: '系统公告',
          component: Notice,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/auth/white',
          name: '管理员白名单',
          component: White,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/spread/index',
          name: '设备分布',
          component: Spread,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/generalDevice/index',
          name: '设备列表',
          component: GeneralDevice,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/weatherDevice/index',
          name: '气象设备列表',
          component: weatherDevice,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/alarm/index',
          name: '报警列表',
          component: alarm,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/protocal/index',
          name: '协议列表',
          component: protocal,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/course/index',
          name: '教程列表',
          component: course,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/log/index',
          name: '设备操作日志列表',
          component: log,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/wechatUser/index',
          name: '微信用户列表',
          component: wechatUser,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/wechatManager/index',
          name: '管理员管理',
          component: wechatManager,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/repair/repair',
          name: '售后维修/维保列表',
          component: Repair,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/apiAuth/index',
          name: '接口授权列表',
          component: apiAuth,
          meta: {
            requireAuth: true
          }
        }
      ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js